import axios from 'axios'
import {apiUrl} from '@/api/base.js'

export default {
    do_clock(args) {
        return axios.post(`${apiUrl}v2/do_clock/`, {params: args})
    },
    get_clock_record(args) {
        return axios.get(`${apiUrl}v2/get_clock_record/`, {params: args})
    }
}
